import "../scss/sms-program.scss";
import { globalDef } from "./modules/siteDefinitions";

const smsForm = document.querySelector<HTMLFormElement>("#sms-form");

if (smsForm) {
    (window as any).loadSmsRecaptcha = () => {
        // Adding recaptcha
        (window as any).smsWidget = grecaptcha.render("g-recaptcha-sms", {
            sitekey: globalDef.recaptchaSiteKey,
            callback: submitSmsForm,
            size: "invisible",
        });
    };

    const smsLoading = smsForm.querySelector<HTMLElement>(".sms-wrap__loading");
    const smsFieldset = smsForm.querySelector<HTMLFieldSetElement>("fieldset");
    const smsEmail = smsForm.querySelector<HTMLInputElement>("input[type=email]");
    const smsCheckbox = smsForm.querySelector<HTMLInputElement>("#checkboxJoinUs")!;
    const smsSubmit = smsForm.querySelector<HTMLInputElement>("#smsSubmitButton")!;
    const smsErrorMessage = smsForm.querySelector<HTMLElement>(".sms-error span")!;

    smsSubmit.disabled = true;

    smsCheckbox.addEventListener("change", () => {
        if (smsCheckbox.checked) {
            smsSubmit.disabled = false;
        } else {
            smsSubmit.disabled = true;
        }
    });

    smsForm.addEventListener("submit", (e) => {
        e.preventDefault();

        if (!globalDef.cmnDebug) {
            grecaptcha.execute();
        } else {
            submitSmsForm();
        }
    });

    var submitSmsForm = async () => {
        const smsFormData = new FormData(smsForm);

        if (!smsEmail?.checkValidity()) {
            smsForm.classList.add("error");
            return;
        }

        if (!smsFieldset) {
            return;
        }

        if (!globalDef.cmnDebug) {
            smsFormData.append("g_recaptcha_response", grecaptcha.getResponse((window as any).smsWidget));
        }

        smsFieldset.disabled = true;

        (smsLoading as any).loading = true;

        const submit = await subscribeToSmsForm(smsFormData)
            .catch((error) => { // Catch error
                if (error && error.responseText) {
                    smsErrorMessage.textContent = `. reason: ${error.responseText}`;
                }

                smsForm.classList.add("error");
                smsFieldset.disabled = false;
                (smsLoading as any).loading = false;
                // This resets recaptcha so user can try again without waiting
                grecaptcha.reset((window as any).smsWidget);
            });

        if (submit === "success") {
            smsForm.style.display = "none";
            smsForm.classList.remove("loading");
            smsForm.classList.remove("error");
            document.querySelector<HTMLElement>(".sms-complete")!.style.display = "block";
        }
    };
}

function subscribeToSmsForm(smsValues: FormData) {
    return new Promise<string>((resolve, reject) => {
        $.ajax({
            url: `${globalDef.ajaxFunctionsUrl}function=submitSms`,
            cache: false,
            type: "post",
            processData: false,
            contentType: false,
            data: smsValues,
            success(response) {
                try {
                    const jsonResp = JSON.parse(response);
                    resolve(jsonResp);
                } catch (e) {
                    reject(e);
                }
            },
            error(error) {
                reject(error);
            },
        });
    });
}